import Http from "@/api/http/fetch/index";
import { isIos } from "@/utils/lodash";
import http from "@/api/http/fetch/index";

const listenStack: any[] = [];

export const addListener = (listen: any) => {
  const { key, fn } = listen;
  listenStack.push({ key, fn });
  initialListener();
  console.log("After addListener:", { listen, listenStack });
};

export const removeListener = (key: string) => {
  const findIndex = listenStack.findIndex((listen: any) => listen.key === key);
  if (findIndex !== undefined && findIndex !== -1) {
    listenStack.splice(findIndex, 1);
  }
  initialListener();
  console.log("After removeListener:", { key, listenStack });
};

export const initialListener = () => {
  Http.SwitchFrontDesk(listenStack);
  Http.AppGoForegroundAndroid(listenStack);
};

const listenBackStack: any[] = [];

export const addGoBackListener = (listen: any) => {
  const { key, fn } = listen;
  listenBackStack.push({ key, fn });
  initialGoBackListener();
};

export const removeGoBackListener = (key: string) => {
  const findIndex = listenBackStack.findIndex(
    (listen: any) => listen.key === key
  );
  if (findIndex !== undefined && findIndex !== -1) {
    listenBackStack.splice(findIndex, 1);
  }
  initialGoBackListener();
  console.log("After removeGoBackListener:", { key, listenStack });
};

export const initialGoBackListener = () => {
  http.SwitchBackgroundDesk(listenBackStack);
};
